var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import search from "@domains/utils/search";
import { EmptyValidation } from "@domains/utils/commonText";
var MutualFundsPresenter = /** @class */ (function () {
    function MutualFundsPresenter(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    MutualFundsPresenter.prototype.getFilters = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecase.mutualFundFilters.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    MutualFundsPresenter.prototype.updateParams = function (req) {
        this.actions.mutualFundsSchemesActions.updateMutualFundsParams(req);
    };
    MutualFundsPresenter.prototype.getMutalFundsSchemes = function (req) {
        var _this = this;
        // if (req.viewAll) {
        //   req.limit = 0;
        // }
        this.actions.mutualFundsSchemesActions.startMutualFundsSchemeLoader();
        this.actions.mutualFundsSchemesActions.updateMutualFundsParams(req);
        this.actions.mutualFundsSchemesActions.hideError();
        this.actions.mutualFundsSchemesActions.clearMsg();
        this.usecase.mutualFundsSchemes.execute({
            onSuccess: function (data) {
                var _a, _b;
                if (data &&
                    (((_a = data.mutualFundsSchemes) === null || _a === void 0 ? void 0 : _a.length) > 0 ||
                        parseInt(req.pageNo.toString()) > 0)) {
                    _this.actions.mutualFundsSchemesActions.getMutualFundsSchemesList(data.mutualFundsSchemes, parseInt(req.pageNo.toString()) > 0, data.totalPages);
                }
                if (data &&
                    ((_b = data.mutualFundsSchemes) === null || _b === void 0 ? void 0 : _b.length) == 0 &&
                    req.pageNo === 0) {
                    _this.actions.mutualFundsSchemesActions.updateMsg({
                        msg: EmptyValidation.noResultsFound,
                        show: true,
                        icon: "",
                    });
                }
                _this.actions.mutualFundsSchemesActions.stopMutualFundsSchemeLoader();
            },
            onError: function (error) {
                _this.actions.mutualFundsSchemesActions.setError({
                    isOpen: true,
                    error: error,
                });
                _this.actions.mutualFundsSchemesActions.stopMutualFundsSchemeLoader();
            },
        }, req);
    };
    MutualFundsPresenter.prototype.applyFilters = function (req) {
        var _this = this;
        if (req.viewAll) {
            req.limit = 0;
        }
        this.actions.mutualFundsSchemesActions.startMutualFundsSchemeTableLoader();
        this.actions.mutualFundsSchemesActions.updateMutualFundsParams(req);
        this.actions.mutualFundsSchemesActions.hideError();
        this.actions.mutualFundsSchemesActions.clearMsg();
        this.usecase.mutualFundsSchemes.execute({
            onSuccess: function (data) {
                var _a;
                if (data && ((_a = data.mutualFundsSchemes) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    _this.actions.mutualFundsSchemesActions.getMutualFundsSchemesList(data.mutualFundsSchemes, parseInt(req.pageNo.toString()) > 0, data.totalPages);
                    _this.actions.mutualFundsSchemesActions.stopMutualFundsSchemeTableLoader();
                }
                else {
                    _this.actions.mutualFundsSchemesActions.updateMsg({
                        msg: EmptyValidation.default,
                        show: true,
                        icon: "",
                    });
                    _this.actions.mutualFundsSchemesActions.stopMutualFundsSchemeTableLoader();
                }
            },
            onError: function (error) {
                _this.actions.mutualFundsSchemesActions.setError({
                    isOpen: true,
                    error: error,
                });
                _this.actions.mutualFundsSchemesActions.stopMutualFundsSchemeTableLoader();
            },
        }, req);
    };
    MutualFundsPresenter.prototype.applySearching = function (searchState, data) {
        var resultData = search(data, "schemeName", searchState);
        if ((resultData === null || resultData === void 0 ? void 0 : resultData.length) === 0) {
            this.actions.mutualFundsSchemesActions.updateMsg({
                msg: EmptyValidation.search.message,
                show: true,
                icon: EmptyValidation.search.icon,
            });
        }
        else {
            this.actions.mutualFundsSchemesActions.clearMsg();
        }
        this.actions.mutualFundsSchemesActions.applySearching({
            searchData: searchState,
        }, resultData);
    };
    MutualFundsPresenter.prototype.applySorting = function (sortRecord, data, sortData) {
        this.actions.mutualFundsSchemesActions.applySorting({
            sortState: sortData,
            sortRecord: sortRecord,
        }, data);
    };
    MutualFundsPresenter.prototype.clearSorting = function () {
        this.actions.mutualFundsSchemesActions.clearSorting();
    };
    MutualFundsPresenter.prototype.clearSearching = function () {
        this.actions.mutualFundsSchemesActions.clearSearching();
        this.actions.mutualFundsSchemesActions.clearMsg();
    };
    MutualFundsPresenter.prototype.exploreFunds = function () {
        var _this = this;
        this.actions.exploreFunds.hideError();
        this.actions.exploreFunds.exploreFundsloader();
        this.usecase.exploreFunds.execute({
            onSuccess: function (data) {
                _this.actions.exploreFunds.exploreFunds(data);
                _this.actions.exploreFunds.exploreFundsstopLoader();
            },
            onError: function (error) {
                _this.actions.exploreFunds.exploreFundsstopLoader();
                _this.actions.exploreFunds.setError({
                    isOpen: true,
                    error: error,
                });
            },
        }, null);
    };
    MutualFundsPresenter.prototype.getMutualFundsHouses = function () {
        var _this = this;
        this.actions.mutualFundsHouseActions.hideError();
        this.usecase.mutualFundsHouse.execute({
            onSuccess: function (data) {
                if (data && data.mutualFundsList)
                    _this.actions.mutualFundsHouseActions.getMutualFundsHousesList(data.mutualFundsList);
            },
            onError: function (error) {
                _this.actions.mutualFundsHouseActions.setError({
                    isOpen: true,
                    error: error,
                });
            },
        }, null);
    };
    MutualFundsPresenter.prototype.getMFCategoryFilters = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mutualFundsCategory.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, request);
        });
    };
    MutualFundsPresenter.prototype.getSchemeCategory = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.schemeCategory.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    MutualFundsPresenter.prototype.mFPurchaseSipCta = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.mfPurchaseSipCtaUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, request);
        });
    };
    MutualFundsPresenter.prototype.clearMutualFundReduxData = function () {
        this.actions.mutualFundsSchemesActions.clearMutualFundReduxData();
    };
    return MutualFundsPresenter;
}());
export default MutualFundsPresenter;
